import { useState, useEffect } from "react"
import { PassareOrganization, getPassareOrganizations } from "../core/_requests"

function useAvailablePassareOrganizations() {
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [availablePassareOrganizations, setAvailablePassareOrganizations] = useState<PassareOrganization[]>([])

    useEffect(() => {
        const fetchOrganizations = async () => {
            try {
                setLoading(true)
                setErrorMessage(null)
                const organizations = await getPassareOrganizations()
                
                // Convert PassareOrganizationWithStats to PassareOrganization format
                // Only show organizations that have API keys (can fetch leads)
                const validOrgs = organizations
                    .filter(org => org.unique_identifier && org.organization_name && org.has_api_key)
                    .map(org => ({
                        unique_identifier: org.unique_identifier,
                        organization_name: org.organization_name,
                        organization_uuid: org.organization_uuid || "",
                    } as PassareOrganization))
                
                setAvailablePassareOrganizations(validOrgs)
            } catch (error) {
                console.error("Failed to fetch Passare organizations:", error)
                setErrorMessage("Failed to load Passare organizations")
                // Fall back to hardcoded list if API fails
                setAvailablePassareOrganizations([
                    {
                        unique_identifier: "porg_O1LK08XQ9yN9jWzOiNAIJ",
                        organization_name: "Public API sandbox",
                        organization_uuid: "dae8b99d-f59c-4812-aef1-1dd3d9fe0148",
                    } as PassareOrganization,
                    {
                        unique_identifier: "porg_2TpSlGHrl1HoMcgPsZJYA",
                        organization_name: "Huff-Guthrie Funeral Home & Cremation Services",
                        organization_uuid: "1ebedc5c-70f0-4cda-95a7-e8577586d67a",
                    } as PassareOrganization,
                    {
                        unique_identifier: "porg_HBMSOUvHy4rE7opSDDUov",
                        organization_name: "Hummel Funeral Home",
                        organization_uuid: "36cb9cea-17fd-4e5a-8a39-9da4354aea33",
                    } as PassareOrganization,
                ])
            } finally {
                setLoading(false)
            }
        }

        fetchOrganizations()
    }, [])

    return {
        availablePassareOrganizations,
        loading,
        errorMessage,
    }
}

export default useAvailablePassareOrganizations